import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TipoRelacionService } from 'src/app/dashboard/services/tipo-relacion.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CustomValidators } from 'src/app/shared/custom-validator/custom-validator.component';

@Component({
  selector: 'app-add-tipo-relacion',
  templateUrl: './add-tipo-relacion.component.html',
  styleUrls: ['./add-tipo-relacion.component.css']
})
export class AddTipoRelacionComponent implements OnInit {
  validatingForm: FormGroup;

  constructor(
    private apiService: TipoRelacionService,
    private auth: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    const language = this.auth.getLanguage() || 'es';
    this.translate.setDefaultLang(language);

    this.validatingForm = new FormGroup({
      signupFormModalName: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ.,()\-_\[\]\/"']{2,255}$/), // control más estricto y amigable
        CustomValidators.secureInput
      ]),
      signupFormModalId: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9_-]{1,100}$/),
        CustomValidators.secureInput
      ]),
      contactFormModalMessage: new FormControl('', [
        Validators.maxLength(4000),
        CustomValidators.secureInput
      ]),
    });
  }

  get signupFormModalId() {
    return this.validatingForm.get('signupFormModalId');
  }

  get signupFormModalName() {
    return this.validatingForm.get('signupFormModalName');
  }

  get contactFormModalMessage() {
    return this.validatingForm.get('contactFormModalMessage');
  }

  addTipoRelacion() {
    if (this.validatingForm.invalid) {
      this.toastr.error(this.translate.instant('texto_318'), this.translate.instant('texto_815'));
      this.validatingForm.markAllAsTouched();
      return;
    }

    const language = this.auth.getLanguage() || 'es';
    const sociedad = this.auth.getSociedad();
    const id = this.signupFormModalId.value.trim();
    const name = this.signupFormModalName.value.trim();
    const comment = this.contactFormModalMessage.value?.trim() || '';

    this.apiService.addRelationType(sociedad, id, name, comment, language).subscribe(
      res => {
        if ((res as any).success === true) {
          this.toastr.success(this.translate.instant('texto_314'), this.translate.instant('texto_316'));
        } else {
          this.toastr.error(this.translate.instant('texto_315'), this.translate.instant('texto_815'));
        }

        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/dashboard/layout/tipo-relacion']);
        });
      },
      err => {
        if (err.status === 409) {
          this.toastr.error(this.translate.instant('texto_315'), this.translate.instant('texto_813'));
        } else {
          this.toastr.error(this.translate.instant('texto_315'), this.translate.instant('texto_813'));
        }
      });
  }

  public options: Object = {
    charCounterCount: true,
    toolbarButtons: [
      'bold', 'italic', 'underline', 'fontFamily', 'fontSize',
      'html', 'backgroundColor', 'textColor',
      'alignLeft', 'alignCenter', 'alignRight',
      'insertLink', '|', 'undo', 'redo'
    ],
    toolbarButtonsXS: [
      'bold', 'italic', 'underline', 'fontFamily', 'fontSize',
      'html', 'backgroundColor', 'textColor',
      'alignLeft', 'alignCenter', 'alignRight',
      'insertLink', '|', 'undo', 'redo'
    ],
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
    imageMaxSize: 5 * 1024 * 1024
  };
}
